/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Core.EftRecordType_
///   This is an auto-generated enumeration of the SWFC_Learning.Core.EftRecordType domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum EftRecordType_ {
   /// <summary>
   ///   Checking (CHK)
   /// </summary>
   Checking = 1,
   /// <summary>
   ///   Savings (SAV)
   /// </summary>
   Savings = 2
}

export const EftRecordTypes: EftRecordType[] = [
   {
      code: EftRecordType_.Checking,
      literal: 'Checking',
      description: 'Checking',
      shortDescription: 'CHK',
      listPriority: 0,

      typeName: "EftRecordType"
   },
   {
      code: EftRecordType_.Savings,
      literal: 'Savings',
      description: 'Savings',
      shortDescription: 'SAV',
      listPriority: 0,

      typeName: "EftRecordType"
   }
]

export class EftRecordType implements IDomainModel {
   code: EftRecordType_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: EftRecordType_): EftRecordType {
      return EftRecordTypes.find(d => d.code === code)
   }
}
